import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App/App';
import { IAppContext, appContextInstance } from './AppContext';
import AppProvider from 'src/components/AppProvider';
import 'lca-common-ui-components/styles.css';
import '@sphera-cloud/component-ui-reactjs/dist/assets/font/InterWeb/inter.css';

import './main.scss';
import './index.css';

const appContext: IAppContext = appContextInstance;

appContext.init().then(() => {
  const root = createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <Router>
      <AppProvider>
        <App context={appContext} />
      </AppProvider>
    </Router>,
  );
});
